import PropTypes from 'prop-types'

import React from 'react'
import { connect } from 'react-redux'
import {
  timeUntilMeetingStarts
} from 'src/services/event_helpers.js'
import { showRsvpModal, showHud } from 'src/actions/frontend'
import {
  requestAcceptInvitation,
  requestDeclineInvitation,
  acceptRsvpInitiated
} from 'src/actions/invitations'
import ActionSheet from 'components/common/ActionSheet/ActionSheet'

import {
  eventSelector,
  userHasTicketsSelector,
  ticketTypesSelector,
  eventTicketCountsSelector,
  invitationSelector,
  ticketTypesCountsSelector
} from 'src/selectors'

class SelfUpdateRsvpActionSheet extends React.Component {
  componentDidMount() {
    const { event } = this.props
    const timeRemaining = timeUntilMeetingStarts(event)

    if (timeRemaining > 0) {
      setTimeout(() => {
        this.forceUpdate()
      }, timeRemaining * 1000 + 30)
    }
  }

  _verifyInvitationGuest = (ticketCounts) => {
    const {
      event: { max_capacity, limit_per_invitation },
      eventTicketCounts,
      ticketTypes,
      invitation: { id: guestId },
      onShowHud
    } = this.props

    const activeTicketTypes = ticketTypes.filter(item => !item.archived_at)
    const activeTypeIds = activeTicketTypes.map(item => item.id)
    const otherAcceptedInvitations = eventTicketCounts.invitations.filter(invitation => invitation.rsvp_state === 'accepted' && invitation.id !== guestId)
    const otherGuest = otherAcceptedInvitations.reduce((sum, invitation) => {
      const invitationTicketCounts = invitation.ticket_counts.filter(tc => {
        return activeTypeIds.includes(tc.ticket_type_id)
      })
      const invitationTotal = invitationTicketCounts.reduce((acc, ticket) => acc + ticket.ticket_count, 0)
      return sum + invitationTotal
    }, 0)

    const totalTickets = ticketCounts.reduce((acc, ticket) => ticket.count + acc, 0)

    if (limit_per_invitation !== 9999 && totalTickets > limit_per_invitation) {
      onShowHud(` This Event allows a maximum of ${limit_per_invitation} Guest(s) per invitation`)
      return false
    }

    if (max_capacity !== 9999 && totalTickets + otherGuest > max_capacity) {
      onShowHud(`Your RSVP exceeds the event's maximum capacity`)
      return false
    }

    return true
  }

  _onAcceptInvitation = () => {
    const { onAcceptInvitation, event, onAcceptRsvpInitiated, userHasTickets, onClose, ticketTypesCounts } =
      this.props

    onClose()

    if (event.ticketing_enabled_at) {
      if (userHasTickets) {
        onAcceptInvitation()
      } else {
        let ticketCounts = []
        ticketTypesCounts.filter(item => !item.archived_at).forEach((item) => {
          if (!item.count) {
            const obj = { ticket_type_id: item.id, count: 1 }
            ticketCounts.push(obj)
          }
        })
        if (this._verifyInvitationGuest(ticketCounts)) {
          onAcceptRsvpInitiated()
        }
      }
    } else {
      onAcceptInvitation()
    }
  }

  _onDeclineInvitation = () => {
    const { onDeclineInvitation, onClose } = this.props
    onClose()
    onDeclineInvitation()
  }

  render() {
    const { isOpenRsvpActionSheet, onClose, headerNode } = this.props

    return (
      <ActionSheet
        visible={isOpenRsvpActionSheet}
        onClose={onClose}
        headerNode={headerNode}
      >
        <ul>
          <li
            onClick={this._onAcceptInvitation}
          >
            Attending
          </li>
          <li
            onClick={this._onDeclineInvitation}
          >
            Not Attending
          </li>
        </ul>
      </ActionSheet>
    )
  }
}

SelfUpdateRsvpActionSheet.propTypes = {
  event: PropTypes.object,
  onAcceptInvitation: PropTypes.func,
  onAcceptRsvpInitiated: PropTypes.func,
  onDeclineInvitation: PropTypes.func,
  userHasTickets: PropTypes.bool,
  eventTicketCounts: PropTypes.object,
  ticketTypes: PropTypes.array,
  invitation: PropTypes.object,
  onShowHud: PropTypes.func,
  ticketTypesCounts: PropTypes.array,

  isOpenRsvpActionSheet: PropTypes.bool,
  onClose: PropTypes.func,
  headerNode: PropTypes.node
}

function mapStateToProps(state) {
  return {
    event: eventSelector(state),
    userHasTickets: userHasTicketsSelector(state),
    invitation: invitationSelector(state),
    ticketTypes: ticketTypesSelector(state),
    eventTicketCounts: eventTicketCountsSelector(state),
    ticketTypesCounts: ticketTypesCountsSelector(state)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onAcceptInvitation: () => dispatch(requestAcceptInvitation()),
    onDeclineInvitation: () => dispatch(requestDeclineInvitation()),
    onAcceptRsvpInitiated: () => {
      dispatch(showRsvpModal())
      dispatch(acceptRsvpInitiated())
    },
    onShowHud: message => dispatch(showHud('error', message))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelfUpdateRsvpActionSheet)
